<template>
  <div style="overflow:hidden">
    <!-- 选择班级 -->
    <el-dialog
      title="班级分组"
      :visible.sync="choose_class_dia"
      
      custom-class='assign_homework_choose_class_dia'
      >
      <div> 选择班级</div>
      <div class="class_list_choose">
        <el-checkbox :indeterminate="isIndeterminateClass" v-model="checkAllClass" @change="handleCheckAllChangeClass">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>

        <el-checkbox-group v-model="class_list_choosed"  @change="handleCheckedCitiesChangeClass">
          <el-checkbox v-if="item.type==1"  v-for="(item,index) in class_list" :key="index" :label="item" >{{item.name}}</el-checkbox>
      </el-checkbox-group>
      </div>
        <div class="choose_group_title">选择分组</div>
      <div class="class_list_choose">
        <el-checkbox :indeterminate="isIndeterminateGroup" v-model="checkAllGroup" @change="handleCheckAllChangeGroup">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="group_list_choosed" @change="handleCheckedCitiesChangeGroup">
          <el-checkbox v-if="item.type==2"  v-for="(item,index) in class_list" :key="index" :label="item" >{{item.name}}</el-checkbox>
      </el-checkbox-group>
      </div>
      <div>
        <div></div>
      </div>
     
    </el-dialog>
     <div class="wrapper_all">
            <div class="wrapper">
            <div class='add_course_head'>
                <div @click="$router.push('/sign_job')"><img src="../../assets/images/course_2.0/返回.png" alt=""></div>
                <div>布置作业</div>
                <div class="add_course_head_save">
                    <div style="opacity:0" > </div>
                    <div @click="save_assgin()" >完成布置</div>
                </div>
            </div>
            <div class="content">
                <!-- 作业内容 -->
                <div class="content_item">
                    <div class="content_item_title">作业内容</div>
                    <div class="assign_type" style="margin-left:0"  @click="change_assign_type(1)">挑选作业</div>
                    <div class="assign_type"  @click="change_assign_type(2)">文本建题</div> 
                        <el-tooltip placement="bottom-start"  popper-class="assign_homework_tips">
                          <div class="el-icon-question icon_question"></div>
                          <div slot="content">文本建题：允许老师上传文本内容建题以及选择题库中现有习题组成作业</div>
                        </el-tooltip>
                    <!-- <div class="assign_type"  @click="change_assign_type(3)">快速建题</div>
                      <el-tooltip placement="bottom"  popper-class="assign_homework_tips">
                        <div class="el-icon-question icon_question"></div>
                        <div slot="content">快速建题：老师通过建立答题卡的方式达到快速建题的目的</div>
                      </el-tooltip>
                    <div class="assign_type"  @click="change_assign_type(4)">框选建题</div>
                      <el-tooltip placement="bottom-end"  popper-class="assign_homework_tips">
                        <div class="el-icon-question icon_question"></div>
                        <div slot="content">框选建题：老师上传图片，通过<br/>裁剪习题，对每道题进行设置</div>
                      </el-tooltip> -->
                </div>
                <!-- 作业列表 -->
                <div class="homework_list">
                    <div class="homework_list_item" v-for="(item,index) in homework_list " :key="index">
                        <div>
                          <img src="../../assets/images/course_2.0/作业.png" alt="" style="width:24px;height:23px">
                        </div>
                        <div>
                          {{item.title}}
                        </div>
                        <div @click="remover_homework(item,index)" class="el-icon-close homework_list_item_close"></div>
                    </div>
                </div>
                <!-- 班级分组 -->
                <div class="content_item">
                    <div class="content_item_title">班级分组</div>
                    <div class='content_item_btn' @click="choose_class_dia=true">继续选择</div>
                </div>
                <!-- 班级分组列表 -->
                <div class="homework_list">
                    <div class="homework_list_item" v-for="(item,index) in class_list_choosed.concat(group_list_choosed) " :key="index">
                      <div>
                        <!-- <div class='homework_list_item_class_icon'>班</div> -->
                        <div class="homework_list_item_group_icon">组</div>
                      </div>
                      <div>
                        {{item.name}}
                      </div>
                      <div @click="remover_class(item,index)" class="el-icon-close homework_list_item_close"></div>
                    </div>
                </div>
                <!-- 作业截止时间 -->
                <div class="content_item assign_homework_content_item content_item_margin">
                    <div class="content_item_title">作业截止时间</div>
                    <div>
                      <el-date-picker
                        v-model="homework_endtime"
                        type="datetime"
                         :picker-options="pickerOptions1"
                        placeholder="请选择作业截止时间">
                      </el-date-picker>
                    </div>
                </div>
                <!-- 批改形式 -->
                <div class="content_item assign_homework_content_item content_item_margin" >
                    <div class="content_item_title">批改形式</div>
                    <el-select v-model="correct_type" placeholder="请选择">
                      <el-option
                        label="老师批改"
                        value="0">
                      </el-option>
                      <el-option
                        label="学生互批"
                        value="1">
                      </el-option>
                      <el-option
                        label="学生自批"
                        value="2">
                      </el-option>
                    </el-select>
                    <div class="content_item_title  correct_set" v-if="correct_type!=0">批改任务截止时间</div>
                    <div v-if="correct_type!=0">
                      <el-date-picker
                        v-model="correct_endtime"
                        type="datetime"
                        placeholder="请选择作业截止时间">
                      </el-date-picker>
                    </div>
                </div>
                 <div class="content_item assign_homework_content_item content_item_margin" >
                    <div class="content_item_title">答案/解析发放</div>
                      <el-radio v-model="show_answer" label="0">到截止时间/全部批改完毕</el-radio>
                      <el-radio v-model="show_answer" label="1">提交作业立马发放</el-radio>

                </div>
                <!-- 答题限时 -->
                <div class="content_item assign_homework_content_item_time content_item_margin">
                     <div class="content_item_title">答题限时</div>
                     <div>
                       <el-switch
                        v-model="limit_answer"
                        active-color="#69B4FF"
                        inactive-color="#cccccc">
                      </el-switch>
                     </div>
                     <div v-if="limit_answer" class="content_item_title correct_set_time ">限制时间</div>
                     <div v-if="limit_answer">
                       <el-input-number :min='0' v-model="limit_answer_time" ></el-input-number>
                        <span style="opacity:0">1</span> <span style="color:#999999"> 分钟</span>
                     </div>
                </div>
                <!-- 作业要求 -->
                <div class="content_item">
                     <div class="content_item_title">作业要求</div>
                </div>
                <!-- textarea 作业要求 -->
                <div class="content_item_remake">
                  <el-input type="textarea" placeholder="请输入内容（选填）......" v-model="homework_require"></el-input>
                </div>
            </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      show_answer:'0',
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      choose_class_dia:false,
      class_list:[],
      class_list_choosed:[],
      group_list_choosed:[],
      checkAllClass:false,
      checkAllGroup:false,
      isIndeterminateClass:true,
      isIndeterminateGroup:true,
      homework_require:'',
      limit_answer_time:30,
      limit_answer:true,
      correct_endtime:'',
      correct_type:'0',
      homework_endtime:'',
      // assign_type_active:1,
      homework_list:[]
    };
  },

  //监听路由变化 控制首页背景图

  created() {

  },
  mounted() {
    //获取时间戳 用来设置默认截止时间
    this.homework_endtime=(Date.parse(new Date())/1000+ 24*60*60)*1000;
    if(this.$route.params.list){
        let obj=this.$route.params.obj
        
          this.homework_list=this.$route.params.list
          this.class_list_choosed=obj.class_list_choosed
          this.group_list_choosed=obj.group_list_choosed
          this.homework_endtime=obj.homework_endtime
          this.correct_type=obj.correct_type
          this.correct_endtime=obj.correct_endtime
          this.limit_answer=obj.limit_answer
          this.limit_answer_time=obj.limit_answer_time
          this.homework_require=obj.homework_require
          this.show_answer=obj.show_answer
          // console.log(obj.show_answer)
    }else{
       this.homework_list=[]
    }
    if(this.$route.params.homeworl_item){
      let arr=[]
      arr.push(this.$route.params.homeworl_item)
      this.homework_list=arr

    }
    this.get_class_list() //获取班级
    // console.log(this.homework_list,'布置')

  },
  methods: {
     
    //完成布置
    save_assgin(){
      let homework_src_list=[]
      console.log(this.homework_list)
      if(this.homework_list.length){
        for(let i in this.homework_list){
          homework_src_list.push({
            homework_src_uuid:this.homework_list[i].homework_uuid||this.homework_list[i].uuid,
            homework_name:this.homework_list[i].title,
            structure_type:0
          })
        }
      }else{
        this.$message({
          type:'error',
          duration:1500,
          message:'请选作业'
        })
        return
      }
      let class_ids=[]
      if(this.class_list_choosed.length||this.group_list_choosed.length){
        for(let i in this.class_list_choosed){
          class_ids.push(this.class_list_choosed[i].id)
        }
        for(let i in this.group_list_choosed){
          class_ids.push(this.group_list_choosed[i].id)
        }
        
      }else{
        this.$message({
          type:'error',
          duration:1500,
          message:'请选择班级'
        })
        return
      }

      let homework_endtime
      if(this.homework_endtime&&typeof(this.homework_endtime)!='number'){
        homework_endtime= this.homework_endtime.getTime() / 1000
      }else{
        if(!this.homework_endtime){
            this.$message({
            type:'error',
            duration:1500,
            message:'请选择作业截止时间'
          })
          return
        }else{
          homework_endtime=this.homework_endtime
        }
      
      }
      let correct_endtime
      if(this.correct_endtime){
         correct_endtime= this.correct_endtime.getTime() / 1000
      }else{
        if(this.correct_type==0){

        }else{
           this.$message({
              type:'error',
              duration:1500,
              message:'请选择批改任务截止时间'
            })
            return
        }
       
      }
      
      
     let data_axios={
       subject_code:sessionStorage.subject_code,
       homework_src_list:homework_src_list,
       class_ids:class_ids.join(','),
       assigned:this.correct_type,
       exchange_end_time:correct_endtime,
       endtime:homework_endtime,
       remark:this.homework_require,
       duration:this.limit_answer_time*60,
       teacher_name:JSON.parse(sessionStorage.userInfo).name,
       show_answer:this.show_answer
     }
     if(!this.limit_answer){
        delete data_axios.duration
     }
     if(this.assigned==0){
        delete data_axios.exchange_end_time
     }
    //  console.log(data_axios)
     this.axios.post("/school/Homework_Usages/addHomeworkUsages2",data_axios).then(res => {
          if (res.data.code == 1) {
             this.$message({
              type: "success",
              message: res.data.msg,
              duration:1500,showClose: true
            });
            this.$router.push('/sign_job')
            // console.log(this.form.class_ids);
            // console.log(this.work_item);
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration:1500,showClose: true
            });
          }
        });

    
    },
    // 修改布置作业类型
    change_assign_type(type){
     
      if(type==1){
        // 挑选
        this.$router.push(
          {
            name:'/homework/homework_list',
            params:{
              list:this.homework_list,
              obj:{
                class_list_choosed:this.class_list_choosed,
                group_list_choosed:this.group_list_choosed,
                homework_endtime:this.homework_endtime,
                correct_type:this.correct_type,
                correct_endtime:this.correct_endtime,
                limit_answer:this.limit_answer,
                limit_answer_time:this.limit_answer_time,
                homework_require:this.homework_require,
                show_answer:this.show_answer

              }//其他需要保存的参数集合
            }
          
          })
      }else if(type==2){
        // 文本
        this.$router.push(
          {
            name:'/homework/homework_edit',
            params:{
              list:this.homework_list,
              obj:{
                class_list_choosed:this.class_list_choosed,
                group_list_choosed:this.group_list_choosed,
                homework_endtime:this.homework_endtime,
                correct_type:this.correct_type,
                correct_endtime:this.correct_endtime,
                limit_answer:this.limit_answer,
                limit_answer_time:this.limit_answer_time,
                homework_require:this.homework_require,
                show_answer:this.show_answer
              }//其他需要保存的参数集合
            }
          
          })
      }else if(type==3){
        // 快速
      }else {
        // 框选
      }
    },
    // 删除作业
    remover_homework(item,index){
       this.$confirm('此操作将删除作业'+ item.title+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.homework_list.splice(index,1)
        }).catch(() => {
               
        });
     
    },
    //删除班级
    remover_class(item,index){
      this.$confirm('此操作将删除班级'+ item.name+', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          for(let i in this.class_list_choosed){
            if(this.class_list_choosed[i].uuid==item.uuid){
              this.class_list_choosed.splice(i,1)
            }
          }
          for(let i in this.group_list_choosed){
            if(this.group_list_choosed[i].uuid==item.uuid){
              this.group_list_choosed.splice(i,1)
            }
          }
           
        }).catch(() => {
               
        });
    },
    //获取班级信息
    get_class_list(){
       this.axios.post("/school/Classes/detail").then(res => {
          if (res.data.code == 1) {
            var arr = res.data.data.data;
            this.class_list=arr
            // console.log(this.form.class_ids);
            // console.log(this.work_item);
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration:1500,showClose: true
            });
          }
        });
    },
    handleCheckAllChangeClass(val) {
        let arr=[]
          for(let i in this.class_list){
            if(this.class_list[i].type==1){
            arr.push(this.class_list[i])
          }
        }
        this.class_list_choosed = val ? arr : [];
        this.isIndeterminateClass = false;
      },
      handleCheckedCitiesChangeClass(value) {
        let arr=[]
        for(let i in this.class_list){
          if(this.class_list[i].type==1){
            arr.push(this.class_list[i])
          }
        }
        let checkedCount = value.length;
        this.checkAllClass = checkedCount === arr.length;
        this.isIndeterminateClass = checkedCount > 0 && checkedCount <arr.length;
      },
      handleCheckAllChangeGroup(val) {
         let arr=[]
        for(let i in this.class_list){
          if(this.class_list[i].type==2){
            arr.push(this.class_list[i])
          }
        }
        this.group_list_choosed = val ? arr : [];
        this.isIndeterminateGroup = false;
      },
      handleCheckedCitiesChangeGroup(value) {
         let arr=[]
        for(let i in this.class_list){
          if(this.class_list[i].type==2){
            arr.push(this.class_list[i])
          }
        }
        let checkedCount = value.length;
        this.checkAllGroup = checkedCount === arr.length;
        this.isIndeterminateGroup = checkedCount > 0 && checkedCount < arr.length;
      }
  }
};
</script>
<style >
  .assign_homework_content_item .el-input__inner{
      height: 40px !important;
      background: #F3F3F3 !important;
      border-radius: 12px 2px 12px 2px !important;
      border: 0 !important;
      cursor: pointer;
    }
    .assign_homework_content_item_time .el-input-number{
      width: 140px;
      height: 40px !important;
      background: #F3F3F3 !important;
      border-radius: 12px 2px 12px 2px !important;
      border: 0 !important;
      cursor: pointer;
    }
     .content_item_remake .el-textarea__inner{
        height: 140px;
        background: #FFFFFF;
        border: 1px solid #DCDFE6;
        border-radius: 20px 6px 20px 6px;
    }
    .assign_homework_tips{
      background:#F3F3F3 !important;
      font-size: 14px !important;
      color: #666666 !important;
      line-height:18px;
    }
    .assign_homework_tips .popper__arrow::after {
    border-bottom-color: #F3F3F3 !important;
   
  }
  .assign_homework_tips .popper__arrow {
    border-bottom-color: #F3F3F3 !important;
    
  }
   .assign_homework_choose_class_dia{
      width: 660px;
      background: #FFFFFF;
      border: 1px solid #69B4FF;
      border-radius: 20px;
    }
</style>
<style scoped>


  .wrapper{
    background: white;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
  }
 .add_course_head{
    margin: 0 20px;
    height: 32px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 17px;
    margin-bottom: 17px;
  }
  .add_course_head img{
    display: block;
    width: 24px;
    height: 20px;
    cursor: pointer;
  }
  .add_course_head_save{
    display: flex;
  }
  .add_course_head_save>div{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    height: 32px;
    line-height: 32px;
    text-align: center;
    box-sizing: border-box;
    background: #69B4FF;
    border-radius: 8px;
    padding: 0 10px;
    cursor: pointer;

  }
  .add_course_head_save >div:nth-of-type(1){
    margin-right: 30px;
  }
   .content{
       height: calc(100vh - 300px);
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        padding: 16px;
        overflow: auto;
    }
    .content_item{
        display: flex;
        align-items: center;
        margin: 10px 0;
        height: 40px;
        line-height: 40px;
    }
    .content_item_title{
      width: 110px;
      text-align: left;
      margin-right: 10px;
    }
    .assign_type{
      height: 32px;
      background: #F3F3F3;
      border-radius: 8px;
      line-height: 32px;
      padding: 0 20px;
      color: #666666;
      cursor: pointer;
      margin: 0 9px 0 24px;
    }
    .icon_question{
      color: #cccccc;
      cursor: pointer;
      font-size: 16px;
    }
    .assign_type:active{
       background: #69B4FF !important;
      color: #FFFFFF !important;
    }
    .assign_type:hover{
       background: #69B4FF !important;
      color: #FFFFFF !important;
    }
    .assign_type_active{
      background: #69B4FF !important;
      color: #FFFFFF !important;
    }
    .homework_list{
      width: 360px;
      background: #F4FAFF;
      border-radius: 20px 2px 20px 2px; 
      margin-left: 120px;
      padding: 0 24px;
      overflow: auto;
    }
    .homework_list_item{
      display: flex;
      height: 18px;
      line-height: 18px;
      align-items: center;
      margin: 24px 0;
    }
    .homework_list_item img{
      display: block;
      width: 22px;
      height: 18px;
      margin-right: 12px;
    }
    .homework_list_item_close{
      display: block;
      margin-left: auto;
      cursor: pointer;
      font-size: 16px;
      color: #666666;
    }
    .content_item_btn{
      height: 32px;
      background: #FF9B36;
      border-radius: 10px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 32px;
      padding: 0 20px;
      cursor: pointer;
    }
    .class_list{
      margin-left: 120px;

    }
    .homework_list_item_group_icon{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      text-align: center;
      background: #FF9B36;
      color: #FFFFFF;
      font-size: 12px;
      line-height: 20px;
      margin-right: 12px;
    }
    .homework_list_item_class_icon{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      text-align: center;
      background: #69B4FF;
      color: #FFFFFF;
      font-size: 12px;
      line-height: 20px;
      margin-right: 12px;
    }
    .correct_set{
      margin-left: 48px;
      width: 160px !important;
    }
    .correct_set_time{
      margin-left: 68px;
      width: 80px !important;
    } 
    .content_item_margin{
      margin: 20px 0 !important ;
    }
    .class_list_choose{
      background: #F8F8F8;
      border-radius: 10px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #808080;
      padding: 16px 20px;
    }
    .choose_group_title{
      margin-top: 16px;
    }
   
 
</style>
